import React, { useState, useRef, useEffect } from "react";
import {
  Form,
  Input,
  Select,
  Skeleton,
  Typography,
  Divider,
  Button,
  Row,
  Col,
  Space,
  Spin,
  message,
} from "antd";
import { AiFillTags } from "react-icons/ai";
import FieldRenderer from "./FieldRenderer";
import { Colors } from "theme";
import { FaEdit } from "react-icons/fa";
import { gaEvent } from "analytics/analytics";
import * as GA from "../../../constants/analytics";
import {
  LoadingOutlined,
  CheckCircleFilled,
  WarningFilled,
  CloseCircleFilled,
} from "@ant-design/icons";
import API_KEY from "api";
import ProductIDModal from "./ProductIDModal";
import { set } from "firebase/database";
import algoliasearch from "algoliasearch/lite";

const searchClient = algoliasearch(
  process.env.REACT_APP_ALGOLIA_CLIENT,
  process.env.REACT_APP_ALGOLIA_KEY
);

const antIcon = <LoadingOutlined spin />;
const { Title, Text } = Typography;
const { Option } = Select;
const FormItem = Form.Item;

export default function BasicDetails({
  onChangeField,
  getCategoryData,
  allCategoryData,
  setAllCategoryData,
  fields,
  hideInfo,
  page,
  showModalVariant,
  variantsData,
  variantsCount,
  setProductId,
  productId,
  setCategoryId,
  categoryId,
  subcategory,
  setSubCategory,
  params,
  form,
}) {
  //const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [productFound, setProductFound] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const productIdRef = useRef();
  const [typing, setTyping] = useState(false);

  const [createCategory, setcreateCategory] = useState(null);
  const [newCategory, setNewCategory] = useState(null);
  const [showAddCategory, setShowAddCategory] = useState(false);
  const [dropdownState, setDropdownState] = useState(false);
  const [showAddCategoryForm, setShowAddCategoryForm] = useState(true);
  const [facetsData, setFacetsData] = useState(null);
  const [onLoadCatCreate, setOnLoadCatCreate] = useState(false);

  const selectRef = useRef();

  const isSubCatPresent = JSON.parse(localStorage.getItem("pref"))
    ? JSON.parse(localStorage.getItem("pref")).sub_category
    : false;

  const ICON_STYLE = {
    fontSize: 24,
    padding: 1,
    background: "#f5f5f5",
    borderRadius: 4,
    color: " #9B9F9E",
    marginRight: 10,
  };
  const ICON_CONTAINER = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "start",
  };

  useEffect(() => {
    if (params?.id && productId && !params?.name && !typing) {
      validateProductId();
    }
  }, [params, productId, page]);

  useEffect(() => {
    let selectedCategory;
    const org = localStorage.getItem("org");
    const orgDetails = org && JSON.parse(org);
    if (allCategoryData && categoryId) {
      allCategoryData.filter((a) => {
        if (a.secondary_category_id.id === categoryId) {
          selectedCategory = a.secondary_category_id.name;
          return a.secondary_category_id.id === categoryId;
        }
      });
    }
    const index = searchClient.initIndex("products");
    const filterSearch = `secondary_category.name:'${selectedCategory}'  AND manufacturer:${orgDetails?.id}`;
    index
      .search(" ", {
        facets: ["sub_category"],
        filters: filterSearch,
      })
      .then((res) => {
        const results = res.facets.sub_category;
        let facetInfo;
        if (results) {
          facetInfo = Object.keys(results);
          setFacetsData(facetInfo);
        } else {
          setFacetsData([]);
        }
      });
  }, [categoryId, allCategoryData]);

  const onChangeCategory = (value) => {
    setNewCategory(value);
    onChangeField(value);
    // getCategoryData(value);
    setCategoryId(value);
  };

  const onChangeProductId = (event) => {
    const value = event?.target?.value;
    if (value) {
      setProductId(value);
      onChangeField(value);
    } else {
      setProductId(null);
      setError(false);
      setLoading(false);
      setProductFound([]);
    }
  };

  const onChangeSubCategory = (event) => {
    const value = event?.target?.value;
    if (value) {
      setSubCategory(value);
      onChangeField(value);
    } else {
      setSubCategory([]);
    }
  };
  const validState = (
    <Row
      align="middle"
      style={{
        marginTop: 6,
        background: "#F1F7FF",
        padding: "0.7em",
        borderRadius: 4,
      }}
    >
      <Space>
        <CheckCircleFilled style={{ fontSize: 18, color: "#4989E9" }} />
        <Title style={{ color: "#363E3D", fontSize: 15 }}>
          No other products found with same ID
        </Title>
      </Space>
    </Row>
  );

  const loadingState = (
    <Row
      align="middle"
      style={{
        marginTop: 6,
        background: "#F5F5F5",
        padding: "12px",
        borderRadius: 4,
      }}
    >
      <Col>
        <Space>
          {" "}
          <Spin indicator={antIcon} spinning={true} />{" "}
          <Title style={{ color: "#828786", fontSize: 16 }}>
            Searching for products with same ID
          </Title>
        </Space>
      </Col>{" "}
    </Row>
  );

  const errorState = (
    <Row
      align="middle"
      justify="space-between"
      style={{
        marginTop: 6,
        background: "#FFF4F4",
        padding: "12px",
        borderRadius: 4,
      }}
    >
      <Col>
        <Space>
          {" "}
          <WarningFilled
            style={{ fontSize: "1.4em", color: "#F78282", marginTop: -5 }}
          />
          <Title style={{ color: "#363E3D", fontSize: 16, margin: 0 }}>
            {productFound.length} other products have same ID
          </Title>
        </Space>
      </Col>
      <Col>
        <Space>
          <Button
            type="link"
            onClick={() => setDismissed(true)}
            style={{ color: "#363E3D", fontSize: 16 }}
          >
            Dismiss
          </Button>
          <Button
            type="link"
            onClick={() => handleView()}
            style={{ color: "#1D2624" }}
          >
            <Title style={{ margin: 0 }} level={5}>
              View
            </Title>
          </Button>
        </Space>
      </Col>
    </Row>
  );

  const productIdState = () => {
    if (productId) {
      return loading
        ? loadingState
        : error
        ? errorState
        : typing
        ? null
        : validState;
    }
  };
  const validateProductId = () => {
    setDismissed(false);
    setTyping(false);
    if (productId) {
      setLoading(true);
      API_KEY.URL.get(API_KEY.path.products, {
        params: {
          "filter[product_id][_eq]": productId,
          fields: `id,product_id,product_images.*,secondary_category.name`,
        },
      })
        .then((res) => {
          setLoading(false);
          const data = res?.data?.data.filter(
            (item) => item.id !== parseInt(params?.id)
          );

          if (data.length > 0) {
            setProductFound(data);
            setError(true);
            productIdRef.current.scrollIntoView({ behavior: "smooth" });
            // productIdRef.current.focus();
          } else {
            setError(false);
            setProductFound([]);
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
          setProductFound([]);
        });
    }
  };
  const handleView = () => {
    showModal();
  };
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  // useEffect(() => {
  //  if(error){
  //   productIdRef.current.scrollIntoView({ behavior: "smooth" });

  //  }
  // }, [error])

  const capitalize = (name) => {
    return name.charAt(0).toUpperCase() + name.slice(1);
  };

  const onNewCategoryInputChange = (event) => {
    setcreateCategory(event.target.value);
    //setNewCategory(event.target.value);
  };

  const fetchCategories = () => {
    setLoading(true);
    API_KEY.URL.get(`${API_KEY.path.manufacturer_secondary_category}`, {
      params: {
        fields: "secondary_category_id.*",
        limit: -1,
      },
    }).then((response) => {
      //setLoading(false);
      setAllCategoryData(response?.data?.data);
      //getCategoryData();

      //setHideInfo(false);
    });
  };

  function isEmpty(val) {
    if (val != null) {
      return val.trim().length === 0;
    } else {
      return val === undefined || val === null || val.length <= 0
        ? true
        : false;
    }
  }

  const handleDone = ({ createCategory }) => {
    setOnLoadCatCreate(true);
    if (!createCategory || isEmpty(createCategory)) {
      //setErrorText("Please select a category");
      message.warning("Please enter a category");
      setOnLoadCatCreate(false);
    } else {
      let element;
      let elementIndex = -1;
      if (allCategoryData) {
        elementIndex = allCategoryData?.findIndex(
          (element) =>
            element?.secondary_category_id?.name.toLowerCase() ===
            createCategory?.toLowerCase()
        );
        if (elementIndex !== -1) element = allCategoryData[elementIndex];
      }
      if (elementIndex === -1) {
        createSecondaryCategory(capitalize(createCategory));
      } else {
        message.warning("Category already exists");
        setOnLoadCatCreate(false);
        // setNewCategory((state) => null);
        //setErrorText((state) => null);
      }
    }
  };

  const createSecondaryCategory = (name) => {
    var org = localStorage.getItem("org");
    const orgId = JSON.parse(org).id;
    const data = {
      primary_category: 4,
      name: name,
      manufacturer: orgId,
    };

    // selectRef?.current?.blur();

    API_KEY.URL.post(API_KEY.path.secondaryCategory, data)
      .then((res) => {
        setAllCategoryData((state) => [
          ...state,
          { id: res?.data?.data?.id, name: res?.data?.data?.name },
        ]);
        message.success("Category added.");
        //((state) => "");
        mapCategoryAndManufacture(res?.data?.data?.id);
        //setIsModalVisible(false);
        setShowAddCategory(false);
        form.setFieldsValue({ secondary_category: res?.data?.data?.id });
        //setNewCategory(name);
        setOnLoadCatCreate(false);
        selectRef?.current?.blur();
      })
      .catch((err) => console.log(err));
  };

  const mapCategoryAndManufacture = (id) => {
    var org = localStorage.getItem("org");
    const orgId = JSON.parse(org).id;
    const data = [
      {
        manufacturer_id: orgId,
        secondary_category_id: id,
      },
    ];

    API_KEY.URL.post(`${API_KEY.path.manufacturer_secondary_category}`, data)
      .then((res) => {
        if (res.status === 200) {
          fetchCategories();
          // setNewCategory((state) => null);
          //setErrorText((state) => null);
        }
      })
      .catch((error) => console.log(error));
  };

  const AddnewCategory = () => {
    setShowAddCategory(true);
  };

  const removeAddCategory = () => {
    setShowAddCategory(false);
  };

  return (
    <div id="basic" style={{ marginTop: "1rem" }}>
      <ProductIDModal
        handleCancel={handleCancel}
        handleOk={handleOk}
        showModal={showModal}
        isModalVisible={isModalVisible}
        productFound={productFound}
      />
      <Title level={4} style={{ fontSize: 16, marginBottom: "2vh" }}>
        1. Basic Details
      </Title>
      <FormItem
        label="Category"
        name="secondary_category"
        rules={[{ required: true, message: "Please select category" }]}
      >
        {allCategoryData ? (
          <Select
            disabled={page === "productByCategory"}
            className="category-select"
            showSearch
            optionFilterProp="children"
            name="InputCategory"
            onFocus={() => {
              setDropdownState(true);
              gaEvent(
                GA.EVENT.HOVER,
                GA.CATEGORY.MASTER_CATALOGUE,
                GA.DESCRIPTION.ADD_NEW_CATEGORY_SELECT_NAME
              );
            }}
            ref={selectRef}
            onSearch={(value, index) => {
              const foundItems = allCategoryData?.filter((category) =>
                category?.secondary_category_id?.name
                  .toLowerCase()
                  .includes(value.toLowerCase())
              );
              if (foundItems.length > 0) {
                setShowAddCategoryForm(true);
              } else {
                setShowAddCategoryForm(false);
              }
            }}
            filterOption={(input, option) => {
              setNewCategory(input);
              return (
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
            placeholder={
              <span style={ICON_CONTAINER}>
                <AiFillTags style={ICON_STYLE} />
                Select Category
              </span>
            }
            onChange={onChangeCategory}
            size="large"
            onClick={() => {
              gaEvent(
                GA.EVENT.CLICK,
                GA.CATEGORY.ADD_PRODUCT,
                GA.DESCRIPTION.BASIC_DETAILS_SELECT_CATEGORIES
              );
            }}
            notFoundContent={
              <Button
                loading={onLoadCatCreate}
                onClick={() => handleDone({ createCategory: newCategory })}
                style={{
                  cursor: "pointer",
                  color: "#0B7764",
                  display: { newCategory },
                  fontWeight: "bold",
                  border: "none",
                  padding: 0,
                  margin: 0,
                }}
              >
                Add '{newCategory}'
              </Button>
            }
            dropdownRender={(menu) => (
              <div>
                {menu}

                {/* <Divider style={{ margin: "4px 0" }} /> */}
                {!showAddCategory && showAddCategoryForm && (
                  <span
                    style={{
                      flex: "none",
                      padding: "8px",
                      display: "block",
                      cursor: "pointer",
                      color: "#0B7764",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                    onClick={AddnewCategory}
                  >
                    Add a Category
                  </span>
                )}

                {showAddCategory ? (
                  <div
                    style={{ display: "flex", flexWrap: "nowrap", padding: 8 }}
                  >
                    <Input
                      style={{ width: "18em" }}
                      value={createCategory}
                      onChange={onNewCategoryInputChange}
                      onClick={() => {
                        gaEvent(
                          GA.EVENT.CLICK,
                          GA.CATEGORY.MASTER_CATALOGUE,
                          GA.DESCRIPTION.ADD_NEW_CATEGORY_INPUT_NAME
                        );
                      }}
                    />
                    <Button
                      style={{
                        flex: "none",
                        padding: "8px",
                        display: "block",
                        cursor: "pointer",
                        border: "none",
                      }}
                      loading={onLoadCatCreate}
                      onClick={() => {
                        handleDone({ createCategory: createCategory });
                        gaEvent(
                          GA.EVENT.CLICK,
                          GA.CATEGORY.MASTER_CATALOGUE,
                          GA.DESCRIPTION.ADD_NEW_CATEGORY_ADD_NEW_ITEM
                        );
                      }}
                    >
                      {/* <PlusOutlined /> Add item */}
                      Done{" "}
                      <CheckCircleFilled
                        style={{ color: "#0B7764", fontSize: "18px" }}
                      />
                    </Button>

                    <span
                      style={{
                        flex: "none",
                        padding: "8px",
                        display: "block",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        removeAddCategory();
                        gaEvent(
                          GA.EVENT.CLICK,
                          GA.CATEGORY.MASTER_CATALOGUE,
                          GA.DESCRIPTION.ADD_NEW_CATEGORY_ADD_NEW_ITEM
                        );
                      }}
                    >
                      {/* <PlusOutlined /> Add item */}
                      Cancel{" "}
                      <CloseCircleFilled
                        style={{ fontSize: "18px", color: "#9B9F9E" }}
                      />
                    </span>
                  </div>
                ) : null}
              </div>
            )}
            value={newCategory ? newCategory : categoryId}
          >
            {allCategoryData?.map(
              (category, index) =>
                category?.secondary_category_id && (
                  <Select.Option
                    key={`${category?.secondary_category_id?.id}_${index}`}
                    value={category?.secondary_category_id?.id}
                    label={
                      <span style={ICON_CONTAINER}>
                        <AiFillTags style={ICON_STYLE} />
                        {category?.secondary_category_id?.name}
                      </span>
                    }
                  >
                    {category?.secondary_category_id?.name}
                  </Select.Option>
                )
            )}
          </Select>
        ) : (
          <Skeleton.Input active />
        )}
      </FormItem>

      <FormItem
        label="Sub Category"
        name="sub_category"
        rules={[{ required: false, message: "Please enter value" }]}
        hidden={!isSubCatPresent}
      >
        <Select
          mode="tags"
          placeholder={`Select or Enter Sub Category`}
          size="large"
          onClick={() => {
            gaEvent(
              GA.EVENT.CLICK,
              GA.CATEGORY.ADD_PRODUCT,
              GA.DESCRIPTION.FIELD_RENDERER_SELECT_INPUT_FIELDS
            );
          }}
          onChange={onChangeSubCategory}

          // value={subcategory}
        >
          {/* WIP facets name may required to be changed */}
          {facetsData && facetsData?.length > 0
            ? facetsData?.map(
                (value, index) =>
                  value && (
                    <Option key={index} value={value}>
                      {value}{" "}
                    </Option>
                  )
              )
            : null}
        </Select>
      </FormItem>

      {/* <FormItem
        label="Sub Category"
        name="sub_category"
        value={subcategory}
        rules={[{ required: false, message: "Please enter value" }]}
      >

          <Select
            //className="category-select"
            showSearch
            optionFilterProp="children"
           
            
            onChange={onChangeSubCategory}
            size="large"
            
           
          >
             {subcategory && subcategory?.length > 0
              ? subcategory?.map(
                  (value, index) =>
                    value && (
                      <Option key={index} value={value}>
                        {value}{" "}
                      </Option>
                    )
                )
              : null}
          </Select>
        



      </FormItem> */}

      <span ref={productIdRef}>
        <FormItem
          label="Product ID"
          name="product_id"
          rules={[{ required: false, message: "Please enter value" }]}
          extra={!dismissed && productIdState()}
        >
          <Input
            size="large"
            onChange={onChangeProductId}
            placeholder="Enter Product Id"
            onClick={() => {
              gaEvent(
                GA.EVENT.CLICK,
                GA.CATEGORY.ADD_PRODUCT,
                GA.DESCRIPTION.BASIC_DETAILS_INPUT_PRODUCT_ID
              );
            }}
            onBlur={validateProductId}
            // onKeyUp={() => setLoading(true)}
            onFocus={() => setTyping(true)}
          />
        </FormItem>
      </span>
      {fields && (
        <FieldRenderer
          fields={fields}
          categoryId={categoryId}
          allCategoryData={allCategoryData}
          form={form}
        />
      )}

      {variantsCount > 0 ? (
        <Row
          justify="space-between"
          align="middle"
          style={{
            background: "#F0F8F6",
            padding: "1em 2em",
            borderRadius: 4,
            cursor: "pointer",
          }}
          onClick={showModalVariant}
        >
          <Col>
            <Row>
              <Title level={5} style={{ margin: "0" }}>
                {`${variantsCount} Variants added against this product`}
              </Title>
            </Row>
            <Row>
              <Text type="secondary">
                Click here to view or edit the details fo the variants
              </Text>
            </Row>
          </Col>
          <Col>
            <FaEdit style={{ fontSize: 24 }} />
          </Col>
        </Row>
      ) : (
        <Button
          disabled={productId && categoryId ? false : true}
          type="dashed"
          size="large"
          onClick={showModalVariant}
          style={{
            width: "100%",
            borderColor:
              productId && categoryId ? Colors.primaryColor : "#B4B7B6",
            color: productId && categoryId ? Colors.primaryColor : "#B4B7B6",
            background: productId && categoryId ? "#F0F8F6" : "none",
          }}
        >
          + Add variant to this product
        </Button>
      )}

      <Divider />
    </div>
  );
}
